/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedFavoritesProvider_viewer$ref = any;
export type DiscoverFeedTiles_viewer$ref = any;
export type DiscoverFeedTiles_viewer = {
    readonly " $fragmentRefs": SharedFavoritesProvider_viewer$ref;
    readonly " $refType": DiscoverFeedTiles_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DiscoverFeedTiles_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SharedFavoritesProvider_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '30dee7cd098f65dd399b55b09f0b4786';
export default node;
